import { DEFAULT_LOCALE, type AppLocale } from '~/utils/i18n';

type HeadCopy = {
  title: string;
  description: string;
};

export const ROOT_ROUTE_HEAD_COPY: Record<AppLocale, HeadCopy> = {
  en: {
    title: 'Trypillian',
    description: 'Welcome to Trypillian',
  },
  // uk: {
  //   title: 'Trypillian',
  //   description: 'Ласкаво просимо до Trypillian',
  // },
};

interface RootHeadConfigOptions {
  locale: AppLocale;
  appStylesHref: string;
}

export const ROOT_ROUTE_HEAD_LINKS = [
  { rel: 'icon', href: '/favicon.svg', type: 'image/svg+xml' },
] as const;

export function createRootHeadConfig({
  locale,
  appStylesHref,
}: RootHeadConfigOptions) {
  const copy =
    ROOT_ROUTE_HEAD_COPY[locale] ?? ROOT_ROUTE_HEAD_COPY[DEFAULT_LOCALE];

  return {
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { title: copy.title },
      { name: 'description', content: copy.description },
    ],
    links: [
      // Preload LCP elements - hero video poster
      { rel: 'preload', as: 'image', href: '/assets/images/first_frame.png', fetchPriority: 'high' as const },
      // Load stylesheet
      { rel: 'stylesheet', href: appStylesHref },
      // Fonts - display=optional makes them non-blocking naturally
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&display=optional' },
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Fragment+Mono:ital@0;1&display=optional' },
      ...ROOT_ROUTE_HEAD_LINKS,
    ],
  };
}
